import {
	Button,
	Checkbox,
	IconButton,
	Menu,
	MenuItem,
	TableCell,
	TableRow,
	Box,
	Typography
} from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import React from 'react';

import { Image, Label } from 'components';
import { useMenu } from 'hooks';
import { ellipsis, properCase, convertVideoToImage } from 'lib/utils';

const FeedbackAttemptItem = ({
	feedbackAttempt,
	isSelectable,
	selectedIds = [],
	handleSelect,
	handleClick,
	handleEditClick,
	handleDeleteClick,
	status,
	...props
}) => {
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			{status !== 'viewed' && (
				<MenuItem onClick={(e) => handleEditClick(feedbackAttempt, e)}>
					Edit
				</MenuItem>
			)}
			<MenuItem onClick={(e) => handleDeleteClick(feedbackAttempt, e)}>
				Delete
			</MenuItem>
		</Menu>
	);

	const isSelected = selectedIds.includes(feedbackAttempt.id);
	return (
		<TableRow>
			{isSelectable && (
				<TableCell>
					<Checkbox
						checked={isSelected ? true : false}
						onChange={() => handleSelect(feedbackAttempt)}
						name="feedback_attempt"
						color="primary"
					/>
				</TableCell>
			)}
			<TableCell>
				<Image
					src={convertVideoToImage(feedbackAttempt.preview)}
					variant="rounded"
					size={80}
					onClick={() => handleClick(feedbackAttempt)}
					style={{ cursor: 'pointer' }}
				/>
			</TableCell>
			<TableCell>
				<Typography
					variant="body2"
					color="text.primary"
					onClick={() => handleClick(feedbackAttempt)}
					style={{ cursor: 'pointer' }}
				>
					{feedbackAttempt?.title}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant="body2"
					color="text.primary"
					onClick={() => handleClick(feedbackAttempt)}
					style={{ cursor: 'pointer' }}
				>
					{feedbackAttempt.full_name}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant="body2"
					color="text.primary"
					onClick={() => handleClick(feedbackAttempt)}
					style={{ cursor: 'pointer' }}
				>
					{feedbackAttempt.skill_category}
				</Typography>
			</TableCell>
			<TableCell>
				<Typography
					variant="body2"
					color="text.primary"
					onClick={() => handleClick(feedbackAttempt)}
					style={{ cursor: 'pointer' }}
				>
					{feedbackAttempt.created_at}
				</Typography>
			</TableCell>
			<TableCell align="right">
				<IconButton onClick={(e) => handleToggleMenu(e)}>
					<MoreHoriz />
					{renderMenu()}
				</IconButton>
			</TableCell>
		</TableRow>
	);
};

export default FeedbackAttemptItem;
